import { Injectable, isDevMode } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { API, BUCKETS, LINKS_CONFIG } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { State } from '../models/state';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SnackBarService } from './snackbar.service';
import { Title } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { AppLoadingService } from './apploading.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthState } from 'src/app/core/auth/auth-state';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { GotoAction, ModalAction } from '../models/action';
import { MatDialog } from '@angular/material/dialog';
import { DialogActionComponent } from '../components/dialog-action/dialog-action.component';
import { AmplifyService } from 'aws-amplify-angular';
import { MaskApplierService, MaskPipe } from 'ngx-mask';

declare var gtag;
declare var $: any;
declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;


@Injectable({
    providedIn: 'root'
})
export class GeneralService {

    private base: any = '/';
    private currentRouter: Router;
    private feature: any;

    private cognitoUser: any;
    private startUrl = '';
    private ADMIN_TYPE = '';

    typeImage: any = ['image/jpeg', 'image/gif', 'image/png', 'image/bmp', 'image/webp'];

    private options = new BehaviorSubject<any>([]);
    options$ = this.options.asObservable();

    private generalData = new BehaviorSubject<any>([]);
    generalData$ = this.generalData.asObservable();

    private adminType = new BehaviorSubject<any>([]);
    adminType$ = this.adminType.asObservable();

    avatarImage: any = [];
    avatarFile: any = '';
    private avatar = new BehaviorSubject<any>([]);
    avatar$ = this.avatar.asObservable();

    private userdata = new BehaviorSubject<any>({});
    userdata$ = this.userdata.asObservable();

    private companies = new BehaviorSubject<any>(null);
    companies$ = this.companies.asObservable();

    private companiesSel = new BehaviorSubject<any>(null);
    companiesSel$ = this.companiesSel.asObservable();

    private settingsLoad = new BehaviorSubject<any>({});
    settingsLoad$ = this.settingsLoad.asObservable();

    public transactionData = new BehaviorSubject<any>({});
    transactionData$ = this.transactionData.asObservable();

    public filesChangeSubscription = new BehaviorSubject<any>([]);
    filesChangeSubscription$ = this.filesChangeSubscription.asObservable();

    public transactionCacheData: any = {};

    private actions = new BehaviorSubject<any>(true);
    actions$ = this.actions.asObservable();

    private accessState = new BehaviorSubject<any>(null);
    accessState$ = this.accessState.asObservable();


    private restrictedAd = new BehaviorSubject<any>({ allowed: [], requested: [] });
    restrictedAd$ = this.restrictedAd.asObservable();

    settingsData: any = {};

    authChecked = new BehaviorSubject<any>(false);
    authChecked$ = this.authChecked.asObservable();


    models: any = {};

    callback = null;

    returnUrl = null;

    private lastCoordinates;

    protected personDataSubscription: Subscription;

    constructor(
        private httpService: HttpService,
        private httpClient: HttpClient,
        protected toast: SnackBarService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private titleService: Title,
        private location: Location,
        private als: AppLoadingService,
        protected authService: AuthService,
        public dialog: MatDialog,
        protected as: AmplifyService,
        protected ms: MaskApplierService
    ) {

        this.personDataSubscription = this.generalData$.subscribe((result) => {
            if (!!result?.person?.length) {
                this.setAvatarFile();
                this.userdata.next(this.getProfiledata());
            }
            if (result?.adFeatures)
                this.feature = result.adFeatures;
        });

    }

    isMobile() {
        return false;
    }

    setTitle(prefix = '', sufix = '') {
        let title = '';
        if (prefix)
            title += prefix + ' | ';

        title += 'Central Corretor';

        if (sufix)
            title += ' | ' + sufix;

        this.titleService.setTitle(title);
    }

    setStartUrl(startUrl) {
        this.startUrl = startUrl;
    }

    setDefaultModule(base, router) {
        this.ADMIN_TYPE = base;

        this.adminType.next(this.ADMIN_TYPE);

        this.base = '/';
        if (this.getValidGroup(base))
            this.base = base;

        this.currentRouter = router;
        const elBody = document.getElementsByTagName("body")[0];
        const elHeader = document.getElementsByTagName("header")[0];
        elBody.setAttribute('module', base.split('?')[0].replace('/', ''));
        elHeader.setAttribute('module', base.split('?')[0].replace('/', ''));

    }

    setLocation(url) {
        this.location.go(this.getBase() + url);
    }

    getBase() {
        if (['emailsignup', 'signUpRealestate'].indexOf(this.base) > -1)
            this.base = '';

        return this.base == '' ? '/' : this.base;
    }
    getRouter() {
        return this.currentRouter;
    }

    getModule() {
        return this.ADMIN_TYPE;
    }

    setAction(data) {
        this.actions.next(data);
    }

    error(error, msg: string = 'Ocorreu um erro') {
        try {
            if (error?.response && error?.response?.status == '400' && error?.response?.data)
                msg = error.response.data.msg;
        } catch (error) {
            console.log(error);
        }

        if (isDevMode())
            console.log(error);

        if (typeof this !== 'undefined')
            this.message(msg);

        return msg;
    }

    message(msg) {
        this.toast.open(msg);
    }

    goTo(lnk: any, event: any = null, options: any = {}) {
        const el: HTMLElement | null = document.getElementById(lnk);
        const scroll = $(el).parents('.scroll').first()[0] || window;

        if (el) {
            setTimeout(() => {
                scroll.scrollTo({
                    top: $(el).offset().top + (options?.offsetTop ? options.offsetTop : 0),
                    behavior: "smooth"
                });

                if (options.callback != undefined) {
                    options.callback(event);
                }

            }, 0);
            return true;
        }

        if (!options?.noRouter)
            this.router.navigate(lnk == 'home' ? [this.getBase()] : lnk.filter(Boolean));
    }

    navigate(commands: any[], extras?: any) {
        this.router.navigate(commands, extras);
    }

    async confirmSignedIn(user: any): Promise<any> {
        //if(this.als.isLoaded('confirmSignedIn'))            return Promise.resolve(true);

        if (user?.pool) {
            this.cognitoUser = user;

            return await this.doConfirmSignedIn(true);

        } else {
            console.error('Unknow object type', user);
            return Promise.resolve(false);
        }
    }

    doClearGeneralData() {
        this.generalData.next({});
        this.userdata.next({});
    }

    async loadPrivateSettings() {

        return await this.httpService.get<any>(API.general.privateSettings, {})//this.cognitoUser.getUsername()
            .then((data) => {
                this.settingsData = { ...this.settingsData, ...data };
                this.settingsLoad.next(this.settingsData);
                return data;
            })
            .catch((error) => {
                this.settingsLoad.next(this.settingsData);
                this.error(error);
                throw error;
            });
    }

    async loadPublicSettings(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpClient.get<any>(API.general.publicSettings, {})
                .subscribe(
                    data => {
                        this.settingsData = { ...this.settingsData, ...data };
                        this.settingsLoad.next(this.settingsData);
                        resolve(true);
                    },
                    (err: HttpErrorResponse) => {
                        this.settingsLoad.next(this.settingsData);
                        resolve(false);
                    });
        });
    }

    async doConfirmSignedIn(changeRouter = true) {
        this.als.setLoaded(false, 'confirmSignedIn');

        let settings = await this.loadPrivateSettings();

        return this.httpService.post<any>(API.general.signin.setArgs([this.cognitoUser.getUsername()]), {})
            .then((result) => {
                let nData = { ...this.settingsData, ...result };

                if (nData?.person[0]?.signature)
                    nData.person[0].signature = this.getFileLink(nData.person[0].signature, nData.person[0].signature_file_id)[0];

                this.generalData.next(nData);
                this.setDefault();

                this.als.setLoaded(true, 'confirmSignedIn');
                let guard = this.getSignUpState();

                if (['SignUpRequiredComplete', 'SignUpRequiredCompleteSent', 'CitiesPreferenceRequired', 'InfoRequired'].indexOf(guard) > -1)
                    this.router.navigate(['/completeSignUp']);
                else if (changeRouter) {
                    let url: string = this.returnUrl || this.activatedRoute.snapshot.queryParams?.returnUrl || this.startUrl;
                    let authUrl = this.getAuthByUrl(result?.person[0]?.perfil_id, url);

                    if (this.startUrl != authUrl && !url.startsWith('/faq')) {
                        if (this.returnUrl) {
                            authUrl = this.returnUrl;
                            this.returnUrl = null;
                        }

                        setTimeout(() => this.navigate([authUrl]), 200);
                    }
                }
            })
            .catch((error) => {
                this.authService.changeAuthState(AuthState.SIGNED_OUT, null);
                this.router.navigate(['/']);
                this.error(error);
                throw error;
            });
    }

    setDefault() {
        this.setCompaniesList();

        let generalData = this.generalData.getValue();

        this.setRestrictedData(generalData);
    }

    setRestrictedData(data) {
        let restrictedAccess = {
            allowed: data?.allowedRestrictedAds || [],
            requested: data?.requestedRestrictedAds || [],
        };
        this.restrictedAd.next(restrictedAccess);
    }

    getAuthByUrl(perfilId, url) {
        let groups = ["realtor"];

        switch (perfilId) {
            case "1": groups = ['realtor', 'builder', 'admin', 'proprietary']; break;
            case "2": groups = ['realtor', 'builder', 'proprietary']; break;
            case "7": groups = ['realtor', 'builder']; break;
        }

        return ['/profile'].indexOf(url) == -1 && !groups.filter(item => url.indexOf(item) > -1).length ? '/' + this.getGroupPriority(perfilId) + '/home' : url;
    }

    getValidGroup(group) {
        let groups = ['realtor', 'admin', 'builder', ''];
        return true;//groups.indexOf(group) > -1;
    }

    getGroupPriority(perfilId) { //Prioridade de acesso de módulo
        switch (perfilId) {
            case "1":
                return "admin";

            case "2":
                return "builder";

        }
        return "realtor";
        /*
        let group = ['realtor','admin','builder'];
        let selGroup = '';
        group.forEach(item => {
            if(groups.indexOf(item) > -1)
                selGroup = item;
        });

        return selGroup;            
        */
    }

    getGeneralData(field = null): any {
        let gd = this.generalData.getValue();
        return field ? gd[field] || [] : gd;
    }

    getStatus(area: any, type: any, id = false, column = null) {
        return this.getAuxiliaryFilter('status', 'id', area, type, id, column);
    }

    getPerfil(area: any, type: any, id = false, column = null) {
        return this.getAuxiliaryFilter(null, 'perfil_id', area, type, id, column);
    }

    getFeatureCategory(id: any, group: any = 'builder') {

        let category = (this?.feature?.ad_category || []).filter(item => item['groups'].indexOf(group) > -1 || group == 'admin' || id != false);

        if (!id)
            return category;

        if (!category.length)
            return false;

        for (var k in category)
            if (category.hasOwnProperty(k)) {
                if (parseInt(category[k].id) == parseInt(id))
                    return category[k];

                if (category[k].items != undefined)
                    for (var i in category[k].items)
                        if (category[k].items.hasOwnProperty(i) && parseInt(category[k].items[i].id) == parseInt(id))
                            return category[k].items[i];

            }
    }

    getTags(area: any, type: any, id: any = false, column = null) {
        return this.getAuxiliaryFilter('tags', 'tag_id', area, type, id, column);
    }

    getProfiledata() {
        let person = this.getGeneralData('person');
        let result: any = !!person.length ? person[0] : {};

        if (result?.person_name)
            result.firstname = result?.person_name?.split(' ')[0];

        return result;
    }


    getStates(id = []) {
        let states = this.getGeneralData('states') || [];
        return !!id.length ? states.filter(item => id.indexOf(parseInt(item.state_id)) > -1) : states;
    }

    getAuxiliaryFilter(prop: any, columnId: any, area: any, type: any, id: any, column: any) {
        let gd = this.getGeneralData(prop);
        if (typeof gd[area] == 'undefined')
            return [];

        let data = gd[area].filter(item => (id == false ? true : (id instanceof Array ? id.indexOf(item[columnId]) > -1 : (typeof id == 'string' ? parseInt(item[columnId]) : item[columnId]) == id)) && (type == false ? true : item['type'].indexOf(type) > -1));

        if (!data.length) {
            return [];
        }

        return id == false || id instanceof Array ? data : (column == null ? data[0] : data[0][column]);
    }

    findCep(cep: string) {
        cep = cep.replace(/\.|\-/g, '');
        return this.httpService.get(API.general.zipcode.setArgs([cep]), null);
    }

    getAssetsFolder() {
        return environment.url + 'assets/';
    }

    getImagesFolder() {
        return this.getAssetsFolder() + 'images/';
    }

    buildImagemUrl(imageName: string) {
        return this.getImagesFolder() + imageName;
    }

    acceptWebp() {
        let isIos = false;
        let isAndroid = false;
        let versionmobile = '0';

        let osVersion = parseInt(versionmobile || "0");

        return isAndroid || (isIos && osVersion >= 14);
    }

    getFileName(file, size, optimize = true, arr: any = false, variation = false): String | Object {

        if (!file?.variations)
            return '';

        let typeNotAccept = optimize && !this.acceptWebp() ? 'image/webp' : '';

        let nfile = variation || (size == 'first' ? file.variations : file.variations.filter(item => item?.resizeType == size && (item?.mime || item?.type) != typeNotAccept))[0];
        let filename = nfile?.filename || nfile?.name || file.filename || '';
        let extension = filename.substr(filename.lastIndexOf('.') + 1);
        // if(extension=='jpg'){
        //     extension = 'jpeg';
        //     filename = filename.replace('.jpg', '.jpeg');
        // }

        //if(!file.extension)
        file.extension = extension;

        if (optimize && this.typeImage.indexOf(file?.mime || 'image/' + extension) > -1) {
            if (!this.acceptWebp() && filename.indexOf('webp') > -1)
                filename = filename.replace('webp', file.extension);

            if (this.acceptWebp() && filename.indexOf('webp') == -1)
                filename = filename.substr(0, filename.lastIndexOf('.')) + '.webp';

        } else if (!file.variations?.length || !file.variations[0]?.filename) {
            filename += "." + file.extension;
        }

        let url = this.getFileUrl(file, filename);

        if (arr) {
            let r = {};
            r[arr] = url;
            r[arr + '_width'] = nfile?.width;
            r[arr + '_height'] = nfile?.height;
            return r;
        }
        return url;

    }


    getFileUrl(file, filename) {
        return [BUCKETS[file.storageBucket || file.storage_bucket], file.storageLevel || file.storage_level, file.storagePath || file.storage_path, filename].join('/')
    }

    async getFile(file, content = false) {
        let src = file.split(content ? (file.indexOf('public/') > -1 ? 'public/' : 'content/') : 'protected/');

        if (content) {
            let file = await this.as.storage().get(src[1], {
                level: '/'
            })
            return file;
        }

        if (typeof src[1] !== 'undefined') {
            let parts = src[1].split('/');

            let signedURL = await this.as.storage().get(parts[1], {
                level: 'protected',
                identityId: parts[0],
                bucket: 'centralcorretor',
                region: 'sa-east-1'
            });
            return signedURL;
        }
        return file;
    }

    setOptions(options) {
        this.options.next(options);
    }
    setBodyClass(data, remove = false) {
        const elBody = document.getElementsByTagName("body")[0];

        if (!remove)
            elBody.classList.add(data);
        else
            elBody.classList.remove(data);
    }
    setSticky(wrapperSticky, objSticky = 'next', callback = null) {
        document.querySelectorAll(wrapperSticky).forEach((observerObj) => {


            var observer = new IntersectionObserver(function (entries) {
                var obj: Element = objSticky == 'next' ? <Element>entries[0].target.nextElementSibling : document.querySelector(objSticky);
                if (obj != null) {

                    if (obj['offsetHeight'] > document.documentElement.clientHeight)
                        obj.classList.add("static");
                    else
                        obj.classList.remove("static");

                    if (entries[0].intersectionRatio === 0) {
                        obj.classList.add("sticky");
                        if (callback)
                            callback(obj, 'sticky');
                    } else {
                        obj.classList.remove("sticky");
                        if (callback)
                            callback(obj, 'unsticky');
                    }


                }

            }, { threshold: [0] });

            observer.observe(observerObj);
        });
    }

    setAvatarFile() {
        let pd = this.getGeneralData('person')[0] || {};
        if (!pd?.avatar)
            return;

        this.avatarImage = this.adjustAvatarFiles(pd);

        this.avatarChange(this.avatarImage);
        return this.avatarImage;
    }

    adjustAvatarFiles(pd, field = 'avatar') {
        if (typeof pd[field] == 'string')
            pd[field] = JSON.parse(pd[field]);

        if (!pd[field]?.link)
            return pd[field];

        let parts = pd[field].link.split('/');
        let filename = parts[2].substr(0, parts[2].lastIndexOf('_') > -1 ? parts[2].lastIndexOf('_') : parts[2].lastIndexOf('.'));
        let extension = parts[2].substr(parts[2].lastIndexOf('.'));
        let direction = 'centered';
        if (pd[field]?.width > pd[field]?.height)
            direction = 'horizontally';

        if (pd[field]?.width < pd[field]?.height)
            direction = 'vertically';

        return [{
            file_id: pd.avatarFileId, status: 1,
            storage_bucket: pd[field].storage_bucket,
            storage_level: parts[0],
            storage_path: parts[1],
            pixel: pd[field]?.pixel,
            sizeDirection: direction,
            width: pd[field]?.width,
            height: pd[field]?.height,
            variations: [
                { filename: filename + '_xl' + extension, resizeType: 'extralarge' },
                { filename: filename + '_lg' + extension, resizeType: 'large' },
                { filename: filename + '_md' + extension, resizeType: 'medium' },
                { filename: filename + '_sm' + extension, resizeType: 'thumb' },
                { filename: filename + '_tn' + extension, resizeType: 'tiny' }
            ]
        }];
    }

    getFileLink(file, fileId) {
        if (typeof file == 'string')
            file = JSON.parse(file);

        if (!file?.link)
            return file;

        let parts = file.link.split('/');
        let filename = parts[2].substr(0, parts[2].lastIndexOf('.'));
        let extension = parts[2].substr(parts[2].lastIndexOf('.'));

        return [{
            file_id: fileId, status: 1,
            storage_bucket: file.storage_bucket,
            storage_level: parts[0],
            storage_path: parts[1],
            pixel: file?.pixel,
            width: file?.width,
            height: file?.height,
            variations: [
                { filename: filename + extension, resizeType: 'original' }
            ]
        }];
    }

    getAvatarFile(files) {
        if (files?.link)
            files = this.adjustAvatarFiles({ avatar: files });

        if (!files?.length)
            return {};

        return {
            data: files[files.length - 1],
            large: this.getFileName(files[files.length - 1], 'large'),
            thumb: this.getFileName(files[files.length - 1], 'thumb'),
            tiny: this.getFileName(files[files.length - 1], 'tiny')
        };
    }

    avatarChange(ev) {
        if (ev === false)
            return this.avatar.next([]);

        if (!!ev.length) {
            this.avatarImage = ev;
            this.avatarFile = this.getAvatarFile(ev);
            this.avatar.next(this.avatarFile);
        }

    }

    getPhoneMask(value) {

        value = value.replace('+', '');
        switch (value?.length) {
            case 13:
                return '+99 (99) 99999-9999';
            case 14:
                return '+99 (999) 99999-9999';
        }
        return '+99 (99) 9999-9999';
    }


    /** COMPANIES */

    getCompaniesdata(list: any = null) {
        if (!list)
            list = this.getGeneralData('companies') || [];

        list = list.map(item => {
            item.avatar = this.adjustAvatarFiles(item);
            item.avatarFile = this.getAvatarFile(item.avatar);
            item.logo = this.adjustAvatarFiles(item, 'logo');
            item.logoFile = this.getAvatarFile(item.logo);
            return item;
        });

        let accept = list.filter(item => item.status == '1');
        let invite = list.filter(item => item.status == '0');

        return { list: list, accept: accept, invite: invite };
    }

    setCompaniesList(renew = false, list = null) {
        if (renew)
            this.httpService.post<any>(API.person.general.companies, {})
                .then((result) => {
                    this.setCompaniesList(false, this.getCompaniesdata(result));
                })
                .catch((error) => this.error(error));

        this.companies.next(list ? list : this.getCompaniesdata());
    }

    getCompaniesList(): any {
        return this.companies.getValue();
    }

    setCompanieSel(id) {
        if (!isNaN(Number(id)))
            this.companiesSel.next(id);
    }
    getCompanieSel() {
        return this.companiesSel.getValue();
    }

    getCompanieData(id) {
        return this.getCompaniesList()?.accept?.filter(item => item.person_friendly_name == id || parseInt(item.company_person_id) == parseInt(id))[0] || {};
    }



    async getCurrentPosition() {
        return {};

        if (this.lastCoordinates)
            return this.lastCoordinates;

        return await navigator.geolocation.getCurrentPosition(coordinates => {
            this.lastCoordinates = coordinates?.coords?.latitude && coordinates?.coords?.longitude ? { lat: coordinates.coords.latitude, lon: coordinates.coords.longitude } : {};
            return this.lastCoordinates;
        }, () => {
            return {};
        }, { timeout: 10000 });
    }

    async event(event, data) {
        return;// Diego Rever
        switch (event) {
            case 'view':
            case 'follow':
                let coordinates = await this.getCurrentPosition();
                this.httpService.post(API.general.event.view.setArgs([data?.type]), {
                    id: data.id,
                    event: event,
                    ...coordinates
                })
                    .catch((err) => {
                        console.log(err);
                    });
                break;
        }
    }

    getSignUpState(companies = null, update = true) {
        let data = this.getProfiledata();

        if (!companies)
            companies = this.getCompaniesdata();
        else
            this.setCompaniesList(false, companies);

        let state = 'AccessSignOut';

        if (data.status == -5) {
            state = 'AccessDisallow';
        } else if (typeof data?.creci_verified == 'undefined' || typeof data?.perfil_id == "undefined") {
            state = 'AccessLoading';

        } else if (data.creci_verified == null && data.perfil_id == "3") {
            state = 'SignUpRequiredComplete';

        } else if (data.creci_verified == "-1" && data.perfil_id == "3") {
            state = 'SignUpRequiredCompleteSent';

        } else if (!data?.address_zipcode) {
            state = 'InfoRequired';

            //if(!data?.cities?.length)            return 'CitiesPreferenceRequired';

        } else if (["2", "7"].indexOf(data.perfil_id) > -1 && !companies?.accept?.length) {
            state = 'AccountRequiredAccept';

        } else if ((data.creci_verified == "1" && data.perfil_id == '3') || data.perfil_id == '1' || (["2", "7"].indexOf(data.perfil_id) > -1 && !!companies?.accept?.length)) {
            state = 'AccessAllow';
        }

        if (update)
            this.accessState.next(state);

        return state;
    }

    calculateDiff(dateSent) {
        let currentDate = new Date();
        dateSent = new Date(dateSent);

        return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) / (1000 * 60 * 60 * 24));
    }

    imgDidLoad(event) {
        event.target.classList.add('loaded');
    }


    async shareLink(data): Promise<any> {
        return await this.httpService.post<any>(API.ad.general.singleshare, data)
            .then(result => {
                let link = LINKS_CONFIG.share_link + result;
                return link;
            })
            .catch((err) => {
                this.error(err);
                return false;
            });
    }

    arrayKeyCustom(array, field, inArray = false) {
        let n = {};
        array.map(item => {
            if (inArray) {
                if (typeof n[item[field]] == 'undefined')
                    n[item[field]] = [];

                n[item[field]].push(item);
            } else
                n[item[field]] = item;
        });
        return n;

    }

    getMenu(group, route, options: any = {}) {

        let user_data: any = this.userdata.getValue();
        let perfil_id = user_data.perfil_id;
        let creci_verified = user_data.creci_verified;
        let companyActive = (this.getCompaniesdata()?.accept?.filter(item => ["4", "5", "6"].indexOf(item.company_person_id) > -1) || [])?.length > 0;

        let menu = [];
        let signedIn = this.authService.getActualAuthState().state == 'signedIn';

        menu.push(new ModalAction('footer', 'Termos e condições', 'TermsComponent'));
        //menu.push(new GotoAction('user','Home', [''], {}, route));

        menu.push(new ModalAction('auth', 'Meu perfil', 'MyProfileComponent'));
        menu.push(new ModalAction('auth', 'Preferências', 'DialogPreferencesComponent'));

        if (signedIn && (companyActive || (creci_verified == '1' && perfil_id == '3'))) {
            //menu.push(new ModalAction('auth','Minhas solicitações', 'DialogRequestListComponent'));
            //menu.push(new ModalAction('auth','Autorizações de venda', 'DialogAuthorizationListComponent'));
            menu.push(new GotoAction(this.getModule() == 'realtor' ? 'header' : 'auth', 'Solicitações', ['realtor', 'requests'], {}, route));

            //            if(isDevMode())
            menu.push(new GotoAction(this.getModule() == 'realtor' ? 'header' : 'auth', 'Contatos', ['realtor', 'leads'], {}, route));
        }

        menu.push(new ModalAction('auth', 'Cadastrar minha imobiliária', 'RealestateComponent'));
        menu.push(new ModalAction('auth', 'Fale conosco', 'FeedbackComponent'));

        if (group != 'realtor' && signedIn) {//(perfil_id == '1' || (["2","7"].indexOf(perfil_id) > -1 && companyActive))){
            menu.push(new GotoAction('user', 'Modo corretor', ['realtor', 'home'], {}, route));
        }

        if (group != 'admin' && perfil_id == '1')
            menu.push(new GotoAction('user', 'Administrador', ['admin', 'home'], {}, route));


        if (group == '' && perfil_id == '1') {// (perfil_id == '3' && creci_verified) || (["2","7"].indexOf(perfil_id) > -1 && companyActive)){
            menu.push(new GotoAction('header', 'Meu painel', ['realtor', 'home'], {}, route));
        }

        return menu;
    }


    openMap(data) {
        window.open('https://www.google.com/maps/?z=19&q=' + (data?.address?.location ? data?.address?.location?.lat + ',' + data?.address?.location?.lon : data.addressText), '_blank');
        /*
        this.getPlatform().ready().then(() => {

            if (isIos) {
              window.open('maps://?q=' + data.addressText + (data?.address?.location ? '&saddr=' + data?.address?.location?.lat + ',' + data?.address?.location?.lon : ''), '_system'); //daddr
            };
      
            if (this.getPlatform().is('android')) {
              window.open('geo://' + (data?.address?.location ? data?.address?.location?.lat + ',' + data?.address?.location?.lon : '') + '?q=' + (data?.address?.location ? data?.address?.location?.lat + ',' + data?.address?.location?.lon : '') + '(' + data.addressText + ')', '_system');
            };
        });
        */
    }

    openProfile(ev, public_idtext, extra = {}) {
        if (public_idtext) {
            this.navigate(['openModal', 'ProfileComponent'], { queryParams: { json: JSON.stringify({ public_idtext: public_idtext, ...extra }) } });
        }
    }


    async requestRestricted(data) {
        if (data?.adId && data?.owner?.personId) {
            const dialogRef2 = this.dialog.open(DialogActionComponent,
                {
                    disableClose: true,
                    data: {
                        title: 'Deseja solicitar acesso?',
                        cancelTitle: 'Não',
                        okTitle: 'Sim'
                    }
                });

            dialogRef2.afterClosed().subscribe(async result => {
                if (result) {
                    await this.httpService.post<any>(API.ad.general.restricted.request, {
                        "ad_id": data.adId,
                        "ad_owner_person_id": data.owner.personId
                    })
                        .then(result => {
                            let list = this.restrictedAd.getValue();
                            list.requested.push(data.adId);
                            this.restrictedAd.next(list);
                        })
                        .catch((err) => {
                            this.error(err);
                            this.requestRestrictedReload();
                        });
                }
            });
        }
    }

    restrictedAdd(data, type = 'requested') {
        let list = this.restrictedAd.getValue();
        list[type].push(data.adId);

        this.restrictedAd.next(list);
    }


    restrictedAllowed(data) {

        if (!data?.restricted || this.getCompanieData(data?.owner?.personFriendlyName || data?.owner?.person_friendly_name || data?.owner_person_id)?.status == 1 || this.restrictedAd.getValue().allowed.indexOf(parseInt(data.adId)) > -1)
            return true;

        if (this.restrictedAd.getValue().requested.indexOf(parseInt(data.adId)) > -1)
            return null;

        return false;

    }

    requestRestrictedReload() {
        this.httpService.post<any>(API.ad.general.restricted.interested, {})
            .then(result => {
                if (result?.allowedRestrictedAds || result?.requestedRestrictedAds) {
                    this.setRestrictedData(result);
                }
            });

    }


    getRequestTypes() {
        return {
            1: {
                title: 'Acesso restrito'
            },
            2: {
                title: 'Material físico'
            },
            3: {
                title: 'Autorização de venda'
            }
        };
    }

    getRequestStatus() {
        return {
            '0': {
                title: 'Pendente',
                icon: 'hourglass-start',
                iconClass: 'blue'
            },
            '1': {
                title: 'Autorizado',
                icon: 'check',
                iconClass: 'green'
            },
            '-1': {
                title: 'Recusado',
                icon: 'times',
                iconClass: 'red'
            },

        };
    }


    getModels(name) {
        return typeof this.models[name] !== 'undefined' ? this.models[name] : {};
    }

    async loadModels(name, endpoint, callback) {

        await this.als.setLoaded(false, 'loadModels');

        const headers = new HttpHeaders()
            .set('Accept', 'text/html')
            .set('Content-Type', 'text/plain; charset=utf-8')
            .set('Access-Control-Allow-Origin', '*');

        return this.httpClient.get(endpoint, { headers: headers, responseType: 'json' })
            .subscribe(
                async data => {
                    this.models[name] = data;
                    this.als.setLoaded(true, 'loadModels');
                    callback(data);
                },
                (err: HttpErrorResponse) => {
                    console.log(err);
                    this.als.setLoaded(true, 'loadModels');
                });

    }

    async loadProfile(public_idtext, owner_person_id = null): Promise<any> {

        return await this.httpService.post<any>(API.person.general.profile, {
            public_idtext: public_idtext,
            ...(owner_person_id ? { owner_person_id: owner_person_id } : {})
        })
            .catch((err) => { this.error(err); })

    }

    track(person_id, event, data) {
        gtag('event', 'click', {
            'person_id': person_id,
            'event_category': event,
            'event_label': data,
            'non_interaction': true
        });
    }


    openGallery(images, index = 0, callback: any = false) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        // Initializes and opens PhotoSwipe

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, {
            index: index, // start at first slide
            preloaderEl: false,
            placeholder: true
        });

        gallery.listen('afterChange', () => {
            let items = gallery.items;
            if (!!items?.length) {
                let cur = gallery.getCurrentIndex();

                Object.entries(items).forEach(([item, v]) => {
                    if (item != cur && items[item]?.content && items[item] && typeof items[item].container !== 'undefined' && items[item]?.container)
                        items[item].container.innerHTML = '';
                });

                if (items[cur]?.content && typeof items[cur].container !== 'undefined')
                    items[cur].container.innerHTML = items[cur]?.content;

                if (items[cur]?.content?.indexOf('video') > -1)
                    pswpElement.classList.add('tiny');
                else
                    pswpElement.classList.remove('tiny');
            } else {
                pswpElement.classList.remove('tiny');
            }
        });

        gallery.close = function () {
            const pswpElement = document.querySelectorAll('.pswp')[0] as HTMLElement;
            pswpElement.classList.remove("pswp--open");
        };

        gallery.init();

        if (typeof callback == 'function')
            callback('open', gallery);
    }

    convertMoneyToDouble(data) {
        if (!!data?.length && data?.indexOf(',') > -1)
            data = data.replace(/\./gi, '').replace(',', '.');

        return data;

    }

    getDate(text) {
        if (text == '' || text == '0000-00-00 00:00:00')
            return null;

        text = (text + (text.indexOf(':') > -1 ? '' : 'T00:00:01')).replace(/-/g, "/").replace('T', ' ').replace('UTC', ' ').replace('Z', ' ').replace('.000', '').replace('+0000', '') + '+0000';
        return text;
    }

    getPhone(phone) {

        const mask = new MaskPipe(this.ms);
        return mask.transform(phone.replace('+', ''), this.getPhoneMask(phone));
    }

    getAcronym(string) {

        var names = string.split(' '),
            initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    }

    openDropdown(event: MouseEvent) {
        if ($(event.target).parent().find('.dropdown-menu').is(":hidden")) {
            $(event.target).dropdown('toggle');
        }
        event.stopPropagation();
    }

    closeDropdown(ev) {
        $('.dropdown-menu.show').removeClass('show');
    }

    copyText(text) {
        const el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.error('', 'Copiado');
    }


}

export class GeneralData {

    followingAds: any[];
    followingPersons: any[];
    groups: any[];
    howyoumeetus: any[];
    modules: any[];
    person: any[];
    states: State[];
    status: any;
    tags: any;
    phrases: any[];
}